import React from 'react';
import { useGame } from '../../context/GameContext';
import './WordCreation.css';

const AdvancedWordCreation = () => {
  const { 
    gameState, 
    currentEra, 
    isMyTurn,
    activePlayerName,
    currentWord,
    wordInputs,
    handleWordInputChange,
    createWord,
    handleKeyPress
  } = useGame();

  // Only show this component in Era 1+ and when game state is word_creation
  if (gameState !== 'word_creation' || currentEra === 0) {
    return null;
  }

  return (
    <div className="word-creation-section">
      <h3>
        {isMyTurn ? 'Create a New Word' : (
          <>
            {typeof activePlayerName === 'string' ? activePlayerName : ''} is Creating a New Word
          </>
        )}
      </h3>
      
      {isMyTurn ? (
        <>
          <p className="instruction-text">
            Create a new spelling for "<strong>{currentWord}</strong>" in the Gibberers language. Your turn will end automatically after you add the word.
          </p>
          <div className="word-creation-container">
            <div className="word-card large-word-card">
              <div className="original-word-display">{currentWord}</div>
              <input
                type="text"
                value={wordInputs[currentWord] || ''}
                onChange={(e) => handleWordInputChange(currentWord, e.target.value)}
                onKeyPress={(e) => handleKeyPress(e, currentWord)}
                placeholder="Enter your new word"
                className="word-card-input"
                autoFocus
              />
              <button 
                onClick={() => createWord(currentWord, wordInputs[currentWord]?.trim())}
                disabled={!wordInputs[currentWord]?.trim()}
                className="word-card-button"
              >
                Add to Dictionary
              </button>
            </div>
          </div>
        </>
      ) : (
        <p className="waiting-text">Waiting for {activePlayerName} to create a new word...</p>
      )}
    </div>
  );
};

export default AdvancedWordCreation; 